import { render, staticRenderFns } from "./TableListNo.vue?vue&type=template&id=20ff8023&scoped=true"
import script from "./TableListNo.vue?vue&type=script&lang=js"
export * from "./TableListNo.vue?vue&type=script&lang=js"
import style0 from "./TableListNo.vue?vue&type=style&index=0&id=20ff8023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff8023",
  null
  
)

export default component.exports